import React, { useState, useMemo, useEffect } from "react";
import { IoEyeOutline, IoKeySharp } from "react-icons/io5";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiEditAlt, BiIdCard } from "react-icons/bi";
import { TiPlus } from "react-icons/ti";
import {
  MdAutorenew,
  MdReceiptLong,
  MdAccountBalanceWallet,
  MdMoneyOff,
  MdCurrencyRupee,
} from "react-icons/md";
import { RiTruckLine } from "react-icons/ri";
import CheckMark from "../../assets/Icons/final approval checker.svg";
import DLTIcon from "../../assets/Icons/DLT.svg";
import "../../css/MasterTable.css";
import { Blocks } from "react-loader-spinner";
import { GrValidate, GrAttachment } from "react-icons/gr";
import { BsClipboardData } from "react-icons/bs";
import CachedIcon from "@mui/icons-material/Cached";
import Pagination from "./Pagination";
import TableDropDownButtonIcon from "../../assets/Icons/TableDropDownButtonIcon.svg";
import TableDropDownOpenButton from "../../assets/Icons/TableDropDownOpenButton.svg";
import ExcelExport from "../../assets/Icons/Excel Export.svg";
import Routes from "../routes/Routes";
import { useLocation, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { FiEye } from "react-icons/fi";
import DltHoverIcon from "../../assets/Icons/DLT_hover.svg";
import CheckMarkHoverIcon from "../../assets/Icons/final approval checker_hover.svg";
import { ICONS } from "../../assets/Icons";
import GetAppIcon from "@mui/icons-material/GetApp";
import { motion } from "framer-motion";
import FilterImg from "../../assets/Images/Funnel.svg";
import { RiLockLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import ReplayIcon from "@mui/icons-material/Replay";
import axios from "axios";
import CustomAlert from "../../helpers/CustomAlert";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isPartnerRole } from "../../utils";

const MasterTable = ({
  optionRefs,
  data,
  headers,
  handleAction,
  filterFields,
  entityType,
  headerToKeyMap,
  loading,
  handleAuth,
  noData,
  pageDetails,
  handleKey,
  RechargeKey,
  BillPaymentKey,
  CourierKey,
  totalRecord,
  pageSize,
  currentPage,
  fetchNextData,
  setCurrentPage,
  setRowData,
  hideAction,
  handleAuditData,
  openModalSms,
  openModalSmsDown,
  openModalRcs,
  openModalRcsDown,
  openModalFilter,
  handleReset,
  filterData,
  fetchData,
  handleRcsKey,
  openModalIpWhit,
  handleProductDetails,
  openModalRcsNew,
  handleRcsAgentDetails,
  handleRcsCallbackUrl,
  handleCreateTemplate,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [sortOrder, setSortOrder] = useState("");
  const [sortFieldData, setSortFieldData] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [hoveredDLTId, setHoveredDLTId] = useState(null);
  const [hoveredCheckerId, setHoveredCheckerId] = useState(null);
  const userRole = sessionStorage.getItem("userRole");

  const { PROTECTED_ROUTES } = Routes();
  const location = useLocation();
  const { menu } = useSelector((state) => state.auth);

  const navigate = useNavigate();
  const array1 = menu;

  const array =
    menu !== null &&
    menu !== undefined &&
    menu !== "" &&
    array1?.split("").map((char) => parseInt(char));

  // Check if filters are applied
  const hasActiveFilters = useMemo(() => {
    if (!filterData) return false;
    return Object.values(filterData).some((value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== "" && value !== null && value !== undefined;
    });
  }, [filterData]);

  // Update showFilters based on active filters
  useEffect(() => {
    if (hasActiveFilters) {
      setShowFilters(true);
    }
  }, [hasActiveFilters, data, currentPage]);

  const CompanyformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.customerCode && userRole === "CUST") {
      activeFilters.push(`Company Id: ${filterData.customerCode}`);
    }
    if (filterData.name && (isGiveAccess || operationTeamRole)) {
      activeFilters.push(`Company Name: ${filterData.name}`);
    }
    if (filterData.gstNumber) {
      activeFilters.push(`GST No.: ${filterData.gstNumber}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.firstContactPersonMobileNo) {
      activeFilters.push(`Mobile No: ${filterData.firstContactPersonMobileNo}`);
    }
    if (filterData.companyPanNumber) {
      activeFilters.push(`PAN No: ${filterData.companyPanNumber}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const UserformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.userId) {
      activeFilters.push(`User Id: ${filterData.userId}`);
    }
    if (filterData.userProfile) {
      activeFilters.push(`Profile: ${filterData.userProfile?.label}`);
    }
    if (filterData.status) {
      activeFilters.push(`Status: ${filterData.status?.label}`);
    }
    if (filterData.name) {
      activeFilters.push(`Company Name: ${filterData.name}`);
    }
    if (filterData.mobileNo) {
      activeFilters.push(`Mobile No: ${filterData.mobileNo}`);
    }
    if (filterData.emailId) {
      activeFilters.push(`Email Id: ${filterData.emailId}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const MWalletformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.userId) {
      activeFilters.push(`User Id: ${filterData.userId}`);
    }
    if (filterData.customerId) {
      activeFilters.push(`Customer Id: ${filterData.customerId}`);
    }
    if (filterData.profile) {
      activeFilters.push(`Profile: ${filterData.profile?.label}`);
    }
    if (filterData.fromAmount) {
      activeFilters.push(`From Amount: ${filterData.fromAmount}`);
    }
    if (filterData.toAmount) {
      activeFilters.push(`To Amount: ${filterData.toAmount}`);
    }
    if (filterData.status && filterData.status.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const ReportformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.companyCode) {
      activeFilters.push(`Company Code: ${filterData?.companyCode}`);
    }
    if (filterData?.fromDate) {
      activeFilters.push(`Start Date: ${filterData?.fromDate}`);
    }
    if (filterData?.toDate) {
      activeFilters.push(`End Date: ${filterData?.toDate}`);
    }
    if (filterData?.fromAmount) {
      activeFilters.push(`Start Amount: ${filterData?.fromAmount}`);
    }
    if (filterData?.toAmount) {
      activeFilters.push(`End Amount: ${filterData?.toAmount}`);
    }

    if (filterData?.billerCategory) {
      activeFilters.push(`Service Type: ${filterData?.billerCategory?.label}`);
    }

    if (filterData?.billerName) {
      activeFilters.push(`Biller Name: ${filterData?.billerName}`);
    }

    if (filterData?.billerStatus?.length > 0) {
      const statusLabels = {
        P: "Pending",
        T: "Processing",
        S: "Success",
        F: "Failed",
      };

      const selectedStatuses = filterData?.billerStatus
        .map((status) => statusLabels[status])
        .filter(Boolean);

      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const OrderformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.retailerId) {
      activeFilters.push(`Retailer Id: ${filterData.retailerId}`);
    }
    if (filterData.consigneeName) {
      activeFilters.push(`Consignee Name: ${filterData.consigneeName}`);
    }
    if (filterData.consigneeMobile) {
      activeFilters.push(`Consignee Mobile: ${filterData.consigneeMobile}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const LedgerformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData?.companyId) {
      activeFilters.push(`Company ID: ${filterData?.companyId}`);
    }
    if (filterData?.fromAmount) {
      activeFilters.push(`Start Amount: ${filterData?.fromAmount}`);
    }
    if (filterData?.toAmount) {
      activeFilters.push(`End Amount: ${filterData?.toAmount}`);
    }
    if (filterData?.fromDate) {
      activeFilters.push(`Start Date: ${filterData?.fromDate}`);
    }
    if (filterData?.toDate) {
      activeFilters.push(`End Date: ${filterData?.toDate}`);
    }

    if (filterData?.drcr) {
      activeFilters.push(`Debit/Credit: ${filterData?.drcr?.label}`);
    }

    if (filterData?.txnType?.length > 0) {
      activeFilters.push(`Transaction Types: ${filterData.txnType.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CourierformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.companyId) {
      activeFilters.push(`Company Id: ${filterData.companyId}`);
    }
    if (filterData.retailerCode) {
      activeFilters.push(`Retailer Code: ${filterData.retailerCode}`);
    }
    if (filterData.pincode) {
      activeFilters.push(`Pincode: ${filterData.pincode}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.status?.length > 0) {
      activeFilters.push(`Status: ${filterData.status.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const SMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Delivered",
      P: "Pending",
      F: "Failed",
      E: "Exception",
      S: "Send",
    };

    if (filterData.userCode && !isGiveAccess) {
      activeFilters.push(`Company Id: ${filterData.userCode}`);
    }
    if (filterData.customerName && isGiveAccess) {
      activeFilters.push(`Company Name: ${filterData.customerName}`);
    }
    if (filterData.mobileNo) {
      activeFilters.push(`Mobile No: ${filterData.mobileNo}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }
    if (filterData.operator?.length > 0) {
      activeFilters.push(`Operator: ${filterData.operator.join(", ")}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BuySMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Completed",
      P: "Pending",
      F: "Failed",
      T: "Timeout",
      S: "Send",
    };

    const serviceType = [
      { value: "BUY_SMS", label: "Buy SMS" },
      { value: "BUY_RCS", label: "Buy RCS" },
      { value: "TOPUP_SMS", label: "Top up SMS" },
      { value: "TOPUP_RCS", label: "Top up RCS" },
    ];

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }

    if (filterData.txnsType) {
      const txnObj = serviceType.find((s) => s.value === filterData.txnsType);
      if (txnObj) {
        activeFilters.push(`Transaction Type: ${txnObj.label}`);
      }
    }

    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }

    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const TopupSMSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const serviceType = [
      { value: "TopUp_SMS", label: "Top Up SMS" },
      { value: "TOPUP_RCS", label: "Top Up RCS" },
    ];

    if (filterData.actionType) {
      const txnObj = serviceType.find((s) => s.value === filterData.actionType);
      if (txnObj) {
        activeFilters.push(`Action Type: ${txnObj.label}`);
      }
    }

    if (filterData.maxTxnAmount) {
      activeFilters.push(`From Amount: ₹${filterData.maxTxnAmount}`);
    }

    if (filterData.minTxnAmount) {
      activeFilters.push(`To Amount: ₹${filterData.minTxnAmount}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }

    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const RCSformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      SENT: "Sent",
      FAILED: "Failed",
      SENT_TO_CUSTOMER: "Sent to Customer",
      DECLINED: "Declined",
      UNREACHABLE_USER: "Unreachable User",
      SEND_MESSAGE_FAILURE: "Send Message Failure",
      SEND_MESSAGE_SUCCESS: "Send Message Success",
      MESSAGE_DELIVERED: "Message Delivered",
      MESSAGE_READ: "Message Read",
      MESSAGE_CLICK: "Message Click",
      INCAPABLE: "Incapable",
    };

    if (filterData.customerName && isGiveAccess) {
      activeFilters.push(`Company Name: ${filterData.customerName}`);
    }

    if (filterData.companyId && !isGiveAccess) {
      activeFilters.push(`Company ID: ${filterData.companyId}`);
    }

    if (filterData.campaignId && !isGiveAccess) {
      activeFilters.push(`Campaign ID: ${filterData.campaignId}`);
    }

    if (filterData.mobileNum) {
      activeFilters.push(`Mobile No: ${filterData.mobileNum}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const CustomerEnquiriesformatFilterDisplay = (filterData) => {
    const activeFilters = [];

    if (filterData.channel) {
      activeFilters.push(`Function Type: ${filterData.channel}`);
    }

    if (filterData.name) {
      activeFilters.push(`Name: ${filterData.name}`);
    }

    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const BulkUploadformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      COMPLETED: "Completed",
      PROCESSING: "Processing",
    };

    if (filterData.sendorId) {
      activeFilters.push(`Sender Id: ${filterData.sendorId}`);
    }
    if (filterData.templateId) {
      activeFilters.push(`Template Id: ${filterData.templateId}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const VendorformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      ACTIVE: "Active",
      INACTIVE: "In-Active",
      BLOCKED: "Blocked",
    };

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.smsType?.label) {
      activeFilters.push(`SMS Type: ${filterData.smsType.label}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const RoleformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      ACTIVE: "Active",
      INACTIVE: "In-Active",
      BLOCKED: "Blocked",
    };

    if (filterData.userProfile?.label) {
      activeFilters.push(`User Profile: ${filterData.userProfile.label}`);
    }
    if (filterData.roleName) {
      activeFilters.push(`Role Name: ${filterData.roleName}`);
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status] || status)
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const VendorTxtHistoryformatFilterDisplay = (filterData) => {
    const activeFilters = [];
    const statusLabels = {
      C: "Success",
      F: "Failed",
    };

    const serviceType = [
      { value: "BUY_SMS", label: "Buy SMS" },
      { value: "BUY_RCS", label: "Buy RCS" },
      { value: "TOPUP_SMS", label: "Top up SMS" },
      { value: "TOPUP_RCS", label: "Top up RCS" },
    ];

    if (filterData.vendorName) {
      activeFilters.push(`Vendor Name: ${filterData.vendorName}`);
    }
    if (filterData.vendorId) {
      activeFilters.push(`Vendor Id: ${filterData.vendorId}`);
    }
    if (filterData.txnsType) {
      const txnObj = serviceType.find((s) => s.value === filterData.txnsType);
      if (txnObj) {
        activeFilters.push(`Transaction Type: ${txnObj.label}`);
      }
    }
    if (filterData.status?.length > 0) {
      const selectedStatuses = filterData.status
        .map((status) => statusLabels[status])
        .filter(Boolean);
      activeFilters.push(`Status: ${selectedStatuses.join(", ")}`);
    }
    if (filterData.fromDate) {
      activeFilters.push(`Start Date: ${filterData.fromDate}`);
    }
    if (filterData.toDate) {
      activeFilters.push(`End Date: ${filterData.toDate}`);
    }

    if (activeFilters.length === 0) {
      return null;
    }

    const [first, ...rest] = activeFilters;
    return rest.length > 0 ? `${first} +${rest.length} more` : first;
  };

  const shouldRenderCreate = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[0]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderEdit = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[1]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderDelete = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[2]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderAuth = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[3]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderAUDIT = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[4]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderDLT = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[5]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderChecker = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[6]?.arr == 1;
    } else {
      return false;
    }
  });

  const shouldRenderSendCredentials = PROTECTED_ROUTES.some((route) => {
    const routeurl = route.url;
    if (routeurl === location.pathname) {
      return route?.grandChild && route.grandChild[7]?.arr == 1;
    } else {
      return false;
    }
  });

  // Toggle row expansion for mobile view
  const toggleRowExpansion = (id) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const filteredData = useMemo(() => {
    if (!data) {
      console.log("No data - returning empty array");
      return [];
    }

    if (!searchTerm || searchTerm.trim() === "") {
      console.log("No search term - returning all data");
      return data;
    }

    const filtered = data?.filter((item) => {
      const matchesSearch = filterFields.some((field) => {
        const value = item[field];
        if (value === null || value === undefined) {
          return false;
        }

        const stringValue = String(value).toLowerCase();
        const searchLower = searchTerm.toLowerCase();

        const matches = stringValue.includes(searchLower);
        return matches;
      });
      return matchesSearch;
    });

    return filtered;
  }, [searchTerm, data, filterFields]);

  const sortedData = useMemo(() => {
    if (!filteredData || !sortFieldData) return filteredData;

    return [...filteredData].sort((a, b) => {
      const fieldA = a[sortFieldData]?.toString().toLowerCase();
      const fieldB = b[sortFieldData]?.toString().toLowerCase();

      if (fieldA < fieldB) return sortOrder === "asc" ? -1 : 1;
      if (fieldA > fieldB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortFieldData, sortOrder]);

  const isNumber = (value) => !isNaN(value) && typeof value === "number";

  const isNumericColumn = (header) => {
    const dataKey = headerToKeyMap[header];
    return data?.some((item) => isNumber(item[dataKey]));
  };

  const handleSortChange = (e, field) => {
    setSortOrder(e.target.value);
    setSortFieldData(field);
  };

  const toggleFilters = () => {
    setShowFilters((prevState) => !prevState);
  };

  const handleToggle = () => {
    toggleFilters();
    handleReset();
    fetchData();
  };

  const showFullContent = (content, key) => {
    let heading = "";
    let displayContent = content;
    if (key === "utrNo") {
      heading = "UTR Number";
    } else if (key === "rcsMessage") {
      heading = "RCS Message";
      try {
        const parsedContent = JSON.parse(content);
        displayContent = JSON.stringify(parsedContent, null, 2);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        displayContent = content;
      }
    } else if (key === "responseDescription") {
      heading = "Response Description";
    } else if (key === "address") {
      heading = "Address";
    } else if (key === "sms") {
      heading = "Message";
    } else {
      heading = "Remark";
    }
    Swal.fire({
      title: heading,
      html: `<pre style="text-align: left; white-space: pre-wrap; word-break: break-all; overflow-x: auto; max-height: 400px;">${displayContent}</pre>`,
      confirmButtonText: "Close",
    });
  };

  const getTooltipValue = (value) => {
    if (value === null || value === undefined || value === "") return "";
    let strValue;
    if (Array.isArray(value)) {
      const filtered = value
        .filter((v) => typeof v !== "object" || v === null)
        .map((v) => String(v))
        .join(", ");
      strValue = filtered;
    } else if (
      typeof value === "object" &&
      value.props &&
      value.props.children
    ) {
      strValue = String(value.props.children);
    } else if (typeof value === "object") {
      try {
        strValue = JSON.stringify(value);
      } catch (e) {
        strValue = "[Invalid Object]";
      }
    } else {
      strValue = String(value);
    }
    // Additional cleanup if needed
    strValue = strValue
      .replace(/,\s*\[object Object\]/g, ",")
      .replace(/\[object Object\],\s*/g, ", ")
      .replace(/\[object Object\]/g, "");
    return strValue.trim();
  };

  const isGiveAccess = userRole === "ADMK" || userRole === "ADCH";

  const operationTeamRole =
    userRole === "OPSMK" ||
    userRole === "OPSCH" ||
    userRole === "MARMK" ||
    userRole === "MAkCH" ||
    userRole === "DEVTEAM" ||
    userRole === "ACCMK" ||
    userRole === "ACCCH";

  const getActionItems = (item) => {
    if (entityType === "CustomerEnquiries") return [];
    const actions = [];

    if (entityType === "Vendor") {
      actions.push({
        icon: (
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginRight: "10px",
            }}
          >
            #
          </span>
        ),
        label: "Sequence",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sequence");
        },
      });
    }

    if (shouldRenderEdit) {
      if (entityType !== "Top-up SMS Request") {
        actions.push({
          icon: <BiEditAlt style={{ marginRight: "10px" }} />,
          label: "Edit",
          onClick: (e) => {
            e.stopPropagation();
            handleAction(item, "modify");
          },
        });
      } else {
        actions.push({
          icon: (
            <img
              src={
                hoveredCheckerId === item.id ? CheckMarkHoverIcon : CheckMark
              }
              alt="CheckMark"
              style={{ height: "14px", cursor: "pointer", marginRight: "10px" }}
              onMouseEnter={() => setHoveredCheckerId(item.id)}
              onMouseLeave={() => setHoveredCheckerId(null)}
            />
          ),
          label: "Checker",
          onClick: (e) => {
            e.stopPropagation();
            handleAuth(item, "modify");
          },
        });
      }
    }

    if (shouldRenderChecker) {
      actions.push({
        icon: (
          <img
            src={hoveredCheckerId === item.id ? CheckMarkHoverIcon : CheckMark}
            alt="CheckMark"
            style={{ height: "14px", cursor: "pointer", marginRight: "10px" }}
            onMouseEnter={() => setHoveredCheckerId(item.id)}
            onMouseLeave={() => setHoveredCheckerId(null)}
          />
        ),
        label: "Checker",
        onClick: (e) => {
          e.stopPropagation();
          handleAuth(item, "check");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleAction(item, "view");
      },
    });

    if (shouldRenderDelete) {
      actions.push({
        icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
        label: entityType !== "Top-up SMS Request" ? "Delete" : "Reject",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "delete");
        },
      });
    }

    if (shouldRenderAuth) {
      actions.push({
        icon: <GrValidate style={{ marginRight: "10px" }} />,
        label:
          entityType !== "Top-up SMS Request" && entityType !== "Top-up Wallet"
            ? "Authorize"
            : "Approve",
        onClick: (e) => {
          e.stopPropagation();
          if (
            entityType === "Top-up SMS Request" ||
            entityType === "Top-up Wallet" ||
            entityType === "Company" ||
            entityType === "Courier"
          ) {
            handleAction(item, "auth");
          } else {
            handleAuth(item);
          }
        },
      });
    }

    if (shouldRenderDLT) {
      actions.push({
        icon: (
          <img
            src={hoveredDLTId === item.id ? DltHoverIcon : DLTIcon}
            alt="DLT"
            style={{ height: "14px", marginRight: "10px" }}
            onMouseEnter={() => setHoveredDLTId(item.id)}
            onMouseLeave={() => setHoveredDLTId(null)}
          />
        ),
        label: "DLT",
        onClick: (e) => {
          e.stopPropagation();
    
          navigate("/dlt", {
            state: {
              customerCode: item.customerCode,
              name: item.name,
              assignedVendorCode: item.assignedVendorCode,
            },
          });
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[71] === 1) ||
      ((isGiveAccess || operationTeamRole) && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <BiIdCard style={{ marginRight: "10px" }} />,
        label: "RCS Key",
        onClick: (e) => {
          e.stopPropagation();
          handleRcsKey(item);
        },
      });
    }

    if (
      array[83] === 1 ||
      (["Company"].includes(entityType) && (isGiveAccess || operationTeamRole))
    ) {
      actions.push({
        icon: <IoKeySharp style={{ marginRight: "10px" }} />,
        label: "SMS Key",
        onClick: (e) => {
          e.stopPropagation();
          handleKey(item);
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[73] === 1) ||
      ((isGiveAccess || operationTeamRole) && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <MdAutorenew style={{ marginRight: "10px" }} />,
        label: "Recharge Key",
        onClick: (e) => {
          e.stopPropagation();
          RechargeKey(item);
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[74] === 1) ||
      ((isGiveAccess || operationTeamRole) && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <MdReceiptLong style={{ marginRight: "10px" }} />,
        label: "Bill Payment Key",
        onClick: (e) => {
          e.stopPropagation();
          BillPaymentKey(item);
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[72] === 1) ||
      ["Courier"].includes(entityType) ||
      ((isGiveAccess || operationTeamRole) && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <RiTruckLine style={{ marginRight: "10px" }} />,
        label: "Courier Key",
        onClick: (e) => {
          e.stopPropagation();
          CourierKey(item);
        },
      });
    }

    if (
      (["Company"].includes(entityType) &&
        userRole !== "CUST" &&
        !operationTeamRole) ||
      (isGiveAccess && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <RiLockLine className="icon-spacing" />,
        label: "Permission",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "authorization");
        },
      });
    }

    if (
      (shouldRenderAUDIT &&
        ["Company", "User", "Vendor", "Top-up Wallet"].includes(entityType)) ||
      ((isGiveAccess || operationTeamRole) && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <BsClipboardData style={{ marginRight: "10px" }} />,
        label: "Audit Trail",
        onClick: (e) => {
          e.stopPropagation();
          handleAuditData(item);
        },
      });
    }

    if (entityType === "Company") {
      actions.push({
        icon: <MdReceiptLong style={{ marginRight: "10px" }} />,
        label: "RCS Callback URL",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "rcsCallbackUrl");
        },
      });
    }

    if (["Company"].includes(entityType) && isGiveAccess) {
      actions.push({
        icon: <MdAccountBalanceWallet style={{ marginRight: "10px" }} />,
        label: "Topup SMS/RCS",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "topup");
        },
      });
      actions.push({
        icon: <MdMoneyOff style={{ marginRight: "10px" }} />,
        label: "Clawback SMS/RCS",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "clawback");
        },
      });
    }

    if (
      ["Company"].includes(entityType) &&
      isGiveAccess &&
      Number(item?.partnerSmsRate) > 0 &&
      Number(item?.partnerRcsRate) > 0
    ) {
      actions.push({
        icon: <MdCurrencyRupee style={{ marginRight: "10px" }} />,
        label: "Change Partner Rate",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "changePartnerRate");
        },
      });
    }

    if (
      shouldRenderSendCredentials &&
      ["User"].includes(entityType) &&
      item?.authStatus === "PENDING_TMID"
    ) {
      actions.push({
        icon: <FaEnvelopeOpenText style={{ marginRight: "10px" }} />,
        label: "Send Credentials",
        onClick: (e) => {
          e.stopPropagation();
          handleAction(item, "sendCredentials");
        },
      });
    }

    if (
      (["Company"].includes(entityType) && array[86] === 1) ||
      (isGiveAccess && ["Company"].includes(entityType)) ||
      (isPartnerRole() && ["Company"].includes(entityType))
    ) {
      actions.push({
        icon: <BiIdCard style={{ marginRight: "10px" }} />,
        label: "RCS Agent Details",
        onClick: (e) => {
          e.stopPropagation();
          handleRcsAgentDetails(item);
        },
      });
    }

    return actions;
  };

  const handleAttachmentClick = (base64String) => {
    const imageSrc = `data:image/jpeg;base64,${base64String}`;

    let scale = 1;

    const handleZoom = (event) => {
      event.preventDefault();
      const zoomImage = document.getElementById("zoomable-image");
      if (!zoomImage) return;

      const rect = zoomImage.getBoundingClientRect();

      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      const originX = (offsetX / rect.width) * 100;
      const originY = (offsetY / rect.height) * 100;

      zoomImage.style.transformOrigin = `${originX}% ${originY}%`;

      if (event.deltaY < 0) {
        scale += 0.1;
      } else {
        scale = Math.max(1, scale - 0.1);
      }

      zoomImage.style.transform = `scale(${scale})`;
    };

    Swal.fire({
      html: `
        <div style="position: relative; overflow: hidden; max-width: 100%; text-align: center;">
          <img 
            src="${imageSrc}" 
            alt="Attachment Image" 
            id="zoomable-image" 
            style="max-width: 80%; transition: transform 0.3s ease;"
          />
        </div>
      `,
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        image: "swal-custom-image",
      },
      willOpen: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.addEventListener("wheel", handleZoom);
      },
      willClose: () => {
        const zoomImage = document.getElementById("zoomable-image");
        zoomImage?.removeEventListener("wheel", handleZoom);
      },
    });
  };

  const downloadFile = async (url, item) => {
    try {
      const response = await axios.get(url, {
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
          Authtoken: sessionStorage.getItem("token") || "",
        },
      });

      if (response?.headers?.authtoken) {
        sessionStorage.setItem("token", response?.headers?.authtoken);
      }

      if (response.status === 200) {
        // Extract filename from Content-Disposition
        let fileName = item?.fileName || "download.xlsx";
        const disposition = response?.headers["content-disposition"];
        if (disposition && disposition?.includes("filename=")) {
          const matches = disposition?.match(/filename="?([^"]+)"?/);
          if (matches?.[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        // Create a blob and trigger download
        const blob = new Blob([response.data], {
          type: response?.headers["content-type"] || "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      if (error?.status === 404) {
        CustomAlert({
          title: "Failed",
          text: "File not found",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    }
  };

  return (
    <div style={{ position: "relative" }} className="master-table-container">
      {loading ? (
        <div className="loader-container">
          <Blocks
            visible={true}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            color="#00b6ce"
          />
        </div>
      ) : (
        <>
          {/* entityType !== "SMS Master" && */}
          {entityType !== "SMS Download Report" && (
            <div className="table-search-main-heading d-flex justify-content-between">
              <div style={{ display: "flex", gap: "10px" }}>
                {entityType !== "User" &&
                  entityType !== "Company" &&
                  entityType !== "Top-up Wallet" &&
                  entityType !== "Report" &&
                  entityType !== "Courier" &&
                  entityType !== "Order" &&
                  entityType !== "SMS Transaction" &&
                  entityType !== "RCS Transaction" &&
                  entityType !== "Ledger" &&
                  entityType !== "Vendor" &&
                  entityType !== "Role" &&
                  entityType !== "Top-up SMS Request" &&
                  entityType !== "Buy SMS" &&
                  entityType !== "Bulk Upload" &&
                  entityType !== "Vendor Txt History" &&
                  entityType !== "SMS Master" &&
                  entityType !== "CustomerEnquiries" &&
                  entityType !== "Pickup Address" && (
                    <div className="table-search-bar">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="🔍 Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  )}
                {/* {shouldRenderCreate ? (
                  <div style={{ display: "flex", gap: "10px" }}>
                    {entityType === "Top-up SMS Request" ? (
                      <>
                        <button
                          className="btn addUser"
                          onClick={() => handleAction("", "add")}
                        >
                          {location.pathname === "/walletActivity"
                            ? "Top-up SMS"
                            : "Top-up SMS Request"}{" "}
                          <TiPlus />
                        </button>
                        {location.pathname === "/walletActivity" &&
                          array[71] === 1 && (
                            <>
                              <button
                                className="btn addUser"
                                onClick={() => handleAction("", "rcs")}
                              >
                                Top-up RCS <TiPlus />
                              </button>
                            </>
                          )}
                      </>
                    ) : (
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          className="btn addUser"
                          onClick={() => handleAction("", "add")}
                        >
                          {entityType === "Top-up SMS" ||
                          entityType === "Buy SMS" ||
                          entityType === "Top-up SMS Request" ||
                          entityType === "Bulk Upload" ||
                          entityType === "Top-up Wallet"
                            ? ""
                            : "Add"}{" "}
                          {entityType} <TiPlus />
                        </button>
                        {location.pathname === "/buysms" && (
                          <>
                            <button
                              className="btn addUser"
                              onClick={() => handleAction("", "rcs")}
                            >
                              Buy RCS
                              <TiPlus />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ) : null} */}
                {/* ✅ Show Top-Up SMS/RCS buttons independently of Create permission */}
                {entityType === "Top-up SMS Request" ? (
                  <div style={{ display: "flex", gap: "10px" }}>
                    {/* If [84] = 1 → Show Top-Up SMS button */}
                    {array[84] === 1 && (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction("", "add")} // Opens TopUPReqModal
                      >
                        Top-up SMS <TiPlus />
                      </button>
                    )}

                    {/* If [85] = 1 → Show Top-Up RCS button */}
                    {array[85] === 1 && (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction("", "rcs")} // Opens TopUpRCSModal
                      >
                        Top-up RCS <TiPlus />
                      </button>
                    )}
                  </div>
                ) : shouldRenderCreate ? (
                  // ✅ All other entity types use Create permission normally
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      className="btn addUser"
                      onClick={() => handleAction("", "add")}
                    >
                      {entityType === "Top-up SMS" ||
                      entityType === "Buy SMS" ||
                      entityType === "Top-up SMS Request" ||
                      entityType === "Bulk Upload" ||
                      entityType === "Top-up Wallet"
                        ? ""
                        : "Add"}{" "}
                      {entityType} <TiPlus />
                    </button>

                    {entityType === "Top-up Wallet" && userRole === "PARTNER" && (
                        <button
                            className="btn addUser"
                            onClick={() => handleAction("", "add_partner")}
                        >
                          Top-up Partner Wallet <TiPlus/>
                        </button>
                    )}
                    {location.pathname === "/buysms" && (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction("", "rcs")}
                      >
                        Buy RCS <TiPlus />
                      </button>
                    )}
                  </div>
                ) : null}

                {/* NEW: Create Order (only for Order) */}
                {entityType === "Order" && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      className="btn addUser"
                      onClick={() => {
                        handleAction("", "add");
                      }}
                    >
                      Create Order
                    </button>

                    <button
                      className="btn addUser"
                      onClick={() => {
                        handleAction("", "cancelShipment");
                      }}
                    >
                      Cancel Shipment
                    </button>
                  </div>
                )}

                {(entityType === "SMS Transaction" ||
                  entityType === "RCS Transaction" ||
                  entityType === "Report" ||
                  entityType === "Ledger" ||
                  entityType === "Order" ||
                  entityType === "CustomerEnquiries") && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    {(entityType === "SMS Transaction" &&
                      userRole !== "CUST") ||
                    entityType === "RCS Transaction" ? (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction(null, "report")}
                      >
                        Report Type
                      </button>
                    ) : (
                      <button
                        className="btn addUser"
                        onClick={
                          entityType === "RCS Transaction"
                            ? openModalRcs
                            : openModalSms
                        }
                      >
                        Full Statement
                      </button>
                    )}

                    <button
                      className="btn addUser"
                      onClick={
                        entityType === "RCS Transaction"
                          ? openModalRcsDown
                          : openModalSmsDown
                      }
                    >
                      Download Report
                    </button>
                  </div>
                )}

                {(entityType === "RCS Transaction" ||
                  entityType === "SMS Transaction") && (
                  <Tooltip
                    title={"Reload"}
                    arrow
                    slotProps={{
                      popper: {
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            fontSize: "16px",
                            padding: "12px 20px",
                            minHeight: "40px",
                          },
                          "& .MuiTooltip-arrow": {
                            fontSize: "1.2em",
                          },
                        },
                      },
                    }}
                  >
                    <div
                      className="w-8 rounded-[6px] flex items-center justify-center cursor-pointer !border !border-[#DDDDDD] !h-9 bg-[#00b6ce] text-[#FFFFFF]"
                      onClick={() => handleAction(null, "reload")}
                    >
                      <ReplayIcon
                        className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
                      />
                    </div>
                  </Tooltip>
                )}

                {entityType === "Report" && (
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button className="btn addUser" onClick={openModalIpWhit}>
                      IP Whitelisting
                    </button>

                    {userRole === "CUST" && (
                      <button
                        className="btn addUser"
                        onClick={() => handleAction("", "recharge")}
                      >
                        Recharge
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div className="sort-controls" style={{ gap: "10px" }}>
                {(entityType === "Company" ||
                  entityType === "User" ||
                  entityType === "Top-up Wallet" ||
                  entityType === "Report" ||
                  entityType === "Courier" ||
                  entityType === "Order" ||
                  entityType === "SMS Transaction" ||
                  entityType === "RCS Transaction" ||
                  entityType === "Ledger" ||
                  entityType === "Vendor" ||
                  entityType === "Role" ||
                  entityType === "Wallet Activity" ||
                  entityType === "Top-up SMS Request" ||
                  entityType === "Buy SMS" ||
                  entityType === "Bulk Upload" ||
                  entityType === "Vendor Txt History" ||
                  entityType === "CustomerEnquiries") && (
                  // entityType === "SMS Master") By omkar
                  <div className="filter-container">
                    {showFilters && (
                      <motion.div
                        initial={{ x: "100%", opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: "100%", opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div
                          className="search-btn"
                          onClick={openModalFilter}
                          style={{ cursor: "pointer" }}
                        >
                          Search/Filter
                        </div>
                      </motion.div>
                    )}

                    {showFilters && (
                      <motion.div
                        initial={{ x: "100%", opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: "100%", opacity: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div
                          className="green-btn"
                          onClick={handleToggle}
                          style={{ cursor: "pointer" }}
                        >
                          <CachedIcon />
                        </div>
                      </motion.div>
                    )}
                    <div className="filter-toggle-box">
                      <img
                        src={FilterImg}
                        alt="funnel"
                        className="funnel-icon"
                        onClick={toggleFilters}
                        style={{ cursor: "pointer" }}
                      />
                      <div
                        className={`filter-text ${
                          filterData &&
                          Object.keys(filterData).length > 0 &&
                          showFilters
                            ? "pr-1"
                            : ""
                        }`}
                      >
                        {filterData &&
                          (entityType === "Company"
                            ? CompanyformatFilterDisplay(filterData)
                            : entityType === "User"
                            ? UserformatFilterDisplay(filterData)
                            : entityType === "Top-up Wallet"
                            ? MWalletformatFilterDisplay(filterData)
                            : entityType === "Report"
                            ? ReportformatFilterDisplay(filterData)
                            : entityType === "Order"
                            ? OrderformatFilterDisplay(filterData)
                            : entityType === "Ledger"
                            ? LedgerformatFilterDisplay(filterData)
                            : entityType === "Courier"
                            ? CourierformatFilterDisplay(filterData)
                            : entityType === "SMS Transaction"
                            ? SMSformatFilterDisplay(filterData)
                            : entityType === "RCS Transaction"
                            ? RCSformatFilterDisplay(filterData)
                            : entityType === "Vendor"
                            ? VendorformatFilterDisplay(filterData)
                            : entityType === "Role"
                            ? RoleformatFilterDisplay(filterData)
                            : entityType === "Buy SMS"
                            ? BuySMSformatFilterDisplay(filterData)
                            : entityType === "Top-up SMS Request"
                            ? TopupSMSformatFilterDisplay(filterData)
                            : entityType === "Bulk Upload"
                            ? BulkUploadformatFilterDisplay(filterData)
                            : entityType === "Vendor Txt History"
                            ? VendorTxtHistoryformatFilterDisplay(filterData)
                            : entityType === "CustomerEnquiries"
                            ? CustomerEnquiriesformatFilterDisplay(filterData)
                            : null)}
                      </div>
                    </div>

                    {/* RCS ICON */}
                    {entityType === "RCS Transaction" && (
                      <Tooltip
                        title={"RCS Dashboard"}
                        arrow
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiTooltip-tooltip": {
                                fontSize: "16px", // bigger text
                                padding: "12px 20px", // more padding = taller tooltip
                                minHeight: "40px", // force height
                              },
                              "& .MuiTooltip-arrow": {
                                fontSize: "1.2em", // bigger arrow
                              },
                            },
                          },
                        }}
                      >
                        <img
                          src={ExcelExport}
                          alt="RCS"
                          style={{
                            width: "40px",
                            height: "40px",
                            cursor: "pointer",
                          }}
                          onClick={openModalRcsNew}
                        />
                      </Tooltip>
                    )}
                  </div>
                )}
                <select
                  className="sort-select appearance-none pr-10"
                  value={sortOrder}
                  onChange={(e) => handleSortChange(e, filterFields)}
                >
                  <option value="" disabled>
                    Sort by Name
                  </option>
                  <option value="asc">Ascending</option>
                  <option value="des">Descending</option>
                </select>
              </div>
            </div>
          )}
          <div
            className="table-responsive container"
            style={{
              marginTop:
                entityType === "SMS Transaction" || entityType === "SMS Master"
                  ? "16px"
                  : "0px",
            }}
          >
            <table className="table table-hover">
              <thead>
                <tr>
                  {![
                    "Buy SMS",
                    "Top-up SMS",
                    "SMS Transaction",
                    "RCS Transaction",
                    "SMS Master",
                    "Bulk Upload",
                    "Report",
                    "Order",
                    "Ledger",
                    "CustomerEnquiries",
                    "Vendor Txt History",
                  ].includes(entityType) &&
                    hideAction !== "hideAction" && (
                      <th
                        style={{
                          width: "80px",
                          maxWidth: "80px",
                        }}
                      >
                        Actions
                      </th>
                    )}
                  {headers?.map((header, index) => (
                    <th
                      key={index}
                      className={`${
                        isNumericColumn(header)
                          ? entityType === "SMS Download Report" ||
                            entityType === "RCS Download Report" ||
                            entityType === "RCS Transaction" ||
                            entityType === "SMS Transaction" ||
                            entityType === "Vendor" ||
                            entityType === "Company" ||
                            entityType === "Buy SMS" ||
                            entityType === "Vendor Txt History" ||
                            entityType === "Top-up SMS Request"
                            ? "text-center"
                            : "text-right"
                          : header === "Action" ? "text-center" : ""
                      } ${
                        header === "Status" && entityType === "RCS Transaction"
                          ? "!w-[223px]"
                          : (header === "Response Description" ||
                              header === "Current Balance(Qty)") &&
                            (entityType === "RCS Transaction" ||
                              entityType === "SMS Transaction")
                          ? "!w-[120px]"
                          : ""
                      }`}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {noData ? (
                  <tr>
                    <td
                      colSpan={headers.length + 1}
                      className="text-start fw-bold"
                    >
                      No data available
                    </td>
                  </tr>
                ) : (
                  sortedData?.map((item, index) => (
                    <>
                      <tr key={item.id}>
                        {![
                          "Buy SMS",
                          "Top-up SMS",
                          "SMS Transaction",
                          "RCS Transaction",
                          "SMS Master",
                          "Bulk Upload",
                          "Report",
                          "Order",
                          "Ledger",
                          "CustomerEnquiries",
                        ].includes(entityType) &&
                          hideAction !== "hideAction" && (
                            <td
                              className="action-icons"
                              style={{ overflow: "visible" }}
                            >
                              <Popover>
                                {({ open, close }) => (
                                  <>
                                    {entityType !== "CustomerEnquiries" && (
                                      <Popover.Button
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "20px",
                                          display: "inline-block",
                                          padding: "0 10px",
                                          background: "none",
                                          border: "none",
                                        }}
                                      >
                                        ⋮
                                      </Popover.Button>
                                    )}
                                    <Transition
                                      as={React.Fragment}
                                      enter="transition ease-out duration-200"
                                      enterFrom="opacity-0 translate-y-1"
                                      enterTo="opacity-100 translate-y-0"
                                      leave="transition ease-in duration-150"
                                      leaveFrom="opacity-100 translate-y-0"
                                      leaveAdapter
                                      leaveTo="opacity-0 translate-y-1"
                                    >
                                      <Popover.Panel
                                        style={{
                                          position: "absolute",
                                          zIndex: 2000,
                                          minWidth: "220px",
                                          backgroundColor: "#ffffff",
                                          boxShadow:
                                            "0 8px 16px rgba(0,0,0,0.25)",
                                          border: "1px solid #d1d5db",
                                          borderRadius: "8px",
                                          padding: "8px 0",
                                          overflow: "visible",
                                        }}
                                      >
                                        {getActionItems(item).map(
                                          (action, idx) => (
                                            <div
                                              key={idx}
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "10px 20px",
                                                cursor: "pointer",
                                                color: "#333",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                transition:
                                                  "background-color 0.2s",
                                                whiteSpace: "nowrap",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#f0f0f0")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#ffffff")
                                              }
                                              onClick={(e) => {
                                                action.onClick(e);
                                                close();
                                              }}
                                            >
                                              {action.icon}
                                              {action.link ? (
                                                action.link
                                              ) : (
                                                <span>{action.label}</span>
                                              )}
                                            </div>
                                          ),
                                        )}
                                      </Popover.Panel>
                                    </Transition>
                                  </>
                                )}
                              </Popover>
                              <div className="dropdown-icons">
                                {!expandedRows[item.id] ? (
                                  <img
                                    src={TableDropDownButtonIcon}
                                    alt="Table Drop Down Button Icon"
                                    onClick={() => toggleRowExpansion(item.id)}
                                    className="icon-spacing"
                                  />
                                ) : (
                                  <img
                                    src={TableDropDownOpenButton}
                                    alt="Table Drop Down Open Button"
                                    onClick={() => toggleRowExpansion(item.id)}
                                    className="icon-spacing"
                                  />
                                )}
                              </div>
                            </td>
                          )}
                        {headers?.map((header, idx) => {
                          const dataKey = headerToKeyMap[header];
                          const fullAddress = [
                            item.address1,
                            item.address2,
                            item.address3,
                            item.pincode,
                            item.city,
                            item.state,
                            item.country,
                          ]
                            .filter(
                              (component) =>
                                component != null && component !== "",
                            )
                            .join(", ");
                          const maxDisplayLength = 14;
                          const smsDisplayLength = 36;
                          const value = item[dataKey];

                          return (
                            <td
                              key={idx}
                              className={isNumber(value) ? "text-center" : ""}
                              title={
                                entityType !== "Top-up SMS Request"
                                  ? getTooltipValue(item[dataKey])
                                  : ""
                              }
                            >
                              {dataKey === "downloadUrl" ? (
                                item.status === "Completed" && value ? (
                                  <div
                                    onClick={() => downloadFile(value, item)}
                                  >
                                    <GetAppIcon
                                      style={{
                                        color: "#14b8a6",
                                        cursor: "pointer",
                                        fontSize: "28px",
                                        verticalAlign: "middle",
                                      }}
                                      title="Download File"
                                    />
                                  </div>
                                ) : (
                                  "-"
                                )
                              ) : dataKey === "remark" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "address" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "sendTxnId" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "sms" && entityType === "SMS Transaction" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full Message"
                                  />
                                </>
                              ) 
                              : dataKey === "smsResponse" && item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "rcsMessage" && item[dataKey] ? (
                                <>
                                  <span>
                                    {(() => {
                                      try {
                                        const parsed = JSON.parse(
                                          item[dataKey],
                                        );
                                        return `${JSON.stringify(
                                          parsed,
                                          null,
                                          2,
                                        ).substring(0, 8)}...`;
                                      } catch {
                                        return `${item[dataKey].substring(
                                          0,
                                          8,
                                        )}...`;
                                      }
                                    })()}
                                  </span>
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full JSON content"
                                  />
                                </>
                              ) : dataKey === "responseDescription" &&
                                item[dataKey] ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "utrNo" &&
                                item[dataKey] &&
                                entityType !== "Top-up Wallet" ? (
                                <>
                                  {item[dataKey].substring(0, 8)}...
                                  <FiEye
                                    className="view-icon"
                                    onClick={() =>
                                      showFullContent(item[dataKey], dataKey)
                                    }
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "8px",
                                    }}
                                    title="View full content"
                                  />
                                </>
                              ) : dataKey === "attachment" && item[dataKey] ? (
                                <>
                                  <GrAttachment
                                    className="icon-spacing"
                                    title="View Attachment"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleAttachmentClick(item[dataKey])
                                    }
                                  />
                                </>
                              ) : [
                                  "authStatus",
                                  "status",
                                  "billerStatus",
                                  "orderStatus",
                                ].includes(dataKey) ? (
                                <span
                                  className={`status-badge ${
                                    [
                                      "ACTIVE",
                                      "SUCCESS",
                                      "COMPLETED",
                                      "SEND",
                                      "APPROVED",
                                      "Completed",
                                      "Success",
                                      "submitted",
                                      "SENT",
                                      "DELIVERED",
                                      "ACCEPTED",
                                      "MESSAGE_DELIVERED",
                                      "SEND_MESSAGE_SUCCESS",
                                      "MESSAGE_READ",
                                      "MESSAGE_CLICK",
                                    ].includes(item[dataKey])
                                      ? "badge-success"
                                      : [
                                          "IN-ACTIVE",
                                          "BLOCK",
                                          "FAIL",
                                          "REJECTED",
                                          "Failed",
                                          "FAILED",
                                          "DECLINED",
                                          "UNREACHABLE_USER",
                                          "SEND_MESSAGE_FAILURE",
                                          "EXCEPTION",
                                        ].includes(item[dataKey])
                                      ? "badge-danger"
                                      : item[dataKey] === "INPROGRESS" ||
                                        item[dataKey] === "Processing" ||
                                        item[dataKey] === "PENDING_TMID" ||
                                        item[dataKey] === "SENT_TO_CUSTOMER"
                                      ? "badge-warning"
                                      : "badge-secondary"
                                  }`}
                                >
                                  {item[dataKey] || item[dataKey] === 0
                                    ? item[dataKey]
                                    : "-"}
                                </span>
                              ) : dataKey === "address" ? (
                                <span
                                  className="address-shortened"
                                  title={fullAddress}
                                >
                                  {fullAddress.length > maxDisplayLength
                                    ? `${fullAddress.substring(
                                        0,
                                        maxDisplayLength,
                                      )}...`
                                    : fullAddress}
                                </span>
                              ) : dataKey === "sms" ? (
                                <span title={item[dataKey]}>
                                  {item[dataKey].length > smsDisplayLength
                                    ? `${item[dataKey].substring(
                                        0,
                                        smsDisplayLength,
                                      )}...`
                                    : item[dataKey]}
                                </span>
                              ) : dataKey === "download" ? (
                                <div style={{ display: "flex", gap: "12px", justifyContent: "center", alignItems: "center" }}>
                                  <Tooltip title="Download Report" arrow>
                                    <img
                                      src={ICONS.DownloadCsvIcon}
                                      alt="DownloadIcon"
                                      onClick={() => setRowData(item)}
                                      style={{ width: "20px", cursor: "pointer" }}
                                    />
                                  </Tooltip>
                                  <Tooltip title="Show Stats" arrow>
                                    <span>
                                      <BsClipboardData
                                        onClick={() => handleAction(item, "showStats")}
                                        style={{ width: "23px", height: "23px", cursor: "pointer", color: "#00B6CE" }}
                                      />
                                    </span>
                                  </Tooltip>
                                </div>
                              ) : dataKey === "products" ? (
                                <>
                                  <FiEye
                                    className="icon-spacing"
                                    title="Product Details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setRowData(item);
                                      handleProductDetails(item);
                                    }}
                                  />
                                </>
                              ) : header === "Option" ? (
                                <span
                                  ref={(el) => {
                                    if (el && item?.id != null) {
                                      optionRefs.current[item.id] = el;
                                    }
                                  }}
                                  className="icon-spacing"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                  }}
                                  title="More Options"
                                  onClick={(e) =>
                                    handleAction(item, "moreOptions")
                                  }
                                >
                                  ⋮
                                </span>
                              ) : item[dataKey] || item[dataKey] === 0 ? item[dataKey] : (
                                " "
                              )}
                            </td>
                          );
                        })}
                      </tr>

                      {/* Render dropdown for additional columns */}
                      {expandedRows[item.id] && (
                        <tr className="dropdown-row">
                          <td colSpan={headers.length + 1}>
                            <div className="dropdown-content">
                              {headers
                                .filter((header, index) => index > 2)
                                .map((header, idx) => {
                                  const dataKey = headerToKeyMap[header];
                                  return (
                                    <div
                                      key={idx}
                                      className="dropdown-row-item"
                                    >
                                      <div className="expanded-row-title">
                                        {header}
                                      </div>
                                      <div className="expanded-row-data">
                                        {item[dataKey]}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}

          {!noData && (
            <Pagination
              currentPage={currentPage}
              totalCount={totalRecord}
              pageSize={pageSize}
              onPageChange={(page) => {
                setCurrentPage(page);
                fetchNextData(page);
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MasterTable;
